// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C768kXp0k5Mh7bSC55nP{justify-content:space-between;align-items:center;width:100%;display:flex}.G7AHUIj3fWkxhJFqKpV0{display:flex}.G7AHUIj3fWkxhJFqKpV0:hover{background:var(--gray-10)}.w2OkytC60NMgoXBQ3VMz{color:var(--content-primary-tertiary);cursor:pointer;margin-left:8px;font-size:13px;font-weight:400;line-height:18px}.rgWlrjntWGwqmxf4CnIv{margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `C768kXp0k5Mh7bSC55nP`,
	"leftContent": `G7AHUIj3fWkxhJFqKpV0`,
	"leftContentText": `w2OkytC60NMgoXBQ3VMz`,
	"cancelButton": `rgWlrjntWGwqmxf4CnIv`
};
export default ___CSS_LOADER_EXPORT___;
